<button
    type="button"
    (click)="onClick.emit($event)"
    [ngClass]="typeClass"
>
    <ng-content></ng-content>
</button>